/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  window.addEventListener('DOMContentLoaded', convertToSentenceCase);
  window.addEventListener('popstate', convertToSentenceCase);

})();

window.onload = function() {
  // Select all elements with the class .allcaps-mini
  const elements = document.querySelectorAll('.allcaps-mini');

  // Iterate over each element
  elements.forEach(function(element) {
    // Check if the element's text contains the word 'DUMÆ'
    if (element.textContent.includes('DUMÆ') || element.textContent.includes('dumæ') ) {
      // Replace 'DUMÆ' with 'test' (case-sensitive replacement)
      element.innerHTML = element.innerHTML.replace(/(\s|^)(dumæ)(\s|$)/gi, '$1<span class="allcaps-mini-lowercase">$2</span>$3');
    }

    if (element.textContent.includes('dumae')) {
      // Replace 'DUMÆ' with 'test' (case-sensitive replacement)
      element.innerHTML = element.innerHTML.replace(/(\s|^)(dumae)(\s|$)/gi, '$1<span class="allcaps-mini-lowercase">$2</span>$3');
    }
  });
};


function convertToSentenceCase(){
  const elements = document.querySelectorAll('.product-item__title, .product__title');
  elements.forEach(element => {
    // Convert the text content to sentence case
    element.textContent = element.textContent
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  });
}

const originalPushState = history.pushState;
history.pushState = function () {
  originalPushState.apply(history, arguments);
  convertToSentenceCase();
};

const originalReplaceState = history.replaceState;
history.replaceState = function () {
  originalReplaceState.apply(history, arguments);
  convertToSentenceCase();
};
